<template>
    <div class="ChoosePackage">
        <topHead class="topHead"><h3 slot="header">套餐变更</h3></topHead>
        <!-- 导航栏 -->
        <!-- 套餐展示 -->
        <div class="mains">
            <van-tabs>
                <van-tab title="北纬移动套餐">
                    <ul class="SetMeal">
                        <li
                            class="SetMealLi"
                            v-for="(item, index) in dayFlows"
                            :key="index"
                            :class="{ SetMeals: dayFlow_li == index }"
                            @click="flowClick(index, item.productId, 'dayFlow')"
                        >
                            <div class="SetMealLeft">
                                <div class="radio">
                                    <p></p>
                                </div>
                            </div>
                            <div class="SetMealRight">
                                <div class="SetMealTitle">
                                    <span>{{ item.name }}</span>
                                    <p>
                                        <em>{{ item.amount }}</em
                                        >元/月
                                    </p>
                                </div>
                                <div class="particulars">
                                    <p
                                        @click="
                                            GoPackageDetails(item.productId)
                                        "
                                    >
                                        详情
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="北纬电信套餐">
                    <ul class="SetMeal">
                        <li
                            class="SetMealLi"
                            v-for="(item, index) in dx"
                            :key="index"
                            :class="{ SetMeals: dayFlows_li == index }"
                            @click="flowClick(index, item.productId, 'dayFlows')"
                        >
                            <div class="SetMealLeft">
                                <div class="radio">
                                    <p></p>
                                </div>
                            </div>
                            <div class="SetMealRight">
                                <div class="SetMealTitle">
                                    <span>{{ item.name }}</span>
                                    <p>
                                        <em>{{ item.amount }}</em
                                        >元/月
                                    </p>
                                </div>
                                <div class="particulars">
                                    <p
                                        @click="
                                            GoPackageDetails(item.productId)
                                        "
                                    >
                                        详情
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>

            <!-- <button @click="aaa">展示套餐</button> -->

            <!-- 底部确认按钮 -->
            <div class="footer">
                <span
                    >套餐费用: <em>{{ currents }} </em>元/月</span
                >
                <van-button @click="flowRecharge">确认变更</van-button>
            </div>
        </div>
        <!-- 提示弹出框 -->
        <Popup
            :show="show"
            confirmText="确认变更"
            @cancel="onCancel()"
            @confirm="openFlow()"
        >
            <div slot="conter" class="conter">
                <p class="conter_phone">
                    <span>更改套餐手机号:</span><em>{{ mobilePhone }}</em>
                </p>

                <p class="conter_money">
                    <span>将要修改为:</span><em>{{ SetMeal }}</em>
                </p>
                <p class="conter_flow">
                    <span>套餐价格:</span><em> {{ currents }} </em>
                </p>
            </div>
            <div class="bottom" slot="bottom">
                套餐一经变更不可恢复原套餐，首月变更次月生效
            </div>
        </Popup>

        <!-- 加载中 -->
        <load :load="load" v-if="load">
            <p slot="text" class="loadText">结果查询中...</p>
        </load>
    </div>
</template>

<script>
import API from "../../../common/api/api"
import { mapState } from "vuex"
import load from "../../../components/load.vue"
import topHead from "../../../components/topHead.vue"
import Popup from "../../../components/Popup.vue"
import { Toast } from "vant"
export default {
    name: "ChoosePackage",
    components: {},
    data() {
        return {
            detail: true,
            mobilePhone: "",
            code: "",
            dayFlow_li: null,
            dayFlows_li: null,
            show: false,
            SetMeal: "",
            currents: "",
            currentss: {},
            newofferId: "",
            dayFlow: [],
            mobilePhone: "",
            packageId: "",
            packageName: "",
            newofferName: "",
            //加载中
            load: false,
            dayFlows: [
                {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 49.9,
                    productId: "1353906",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬移动流量卡20G",
                    smsin: "0条",
                    monthfee: "43.9",
                    datain: "20GB",
                },
                {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 9.9,
                    productId: "1353924",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬标准流量卡",
                    smsin: "0条",
                    monthfee: "3.9",
                    datain: "0GB",
                },
                {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 159.9,
                    productId: "1353935",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬移动流量卡50G",
                    smsin: "0条",
                    monthfee: "3.9",
                    datain: "0GB",
                },
            ],

            dx: [
                   {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 19.9,
                    productId: "1353923",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬电信流量卡5G",
                    smsin: "0条",
                    monthfee: "13.9",
                    datain: "5GB",
                },
                {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 29.9,
                    productId: "1353907",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬电信流量卡10G",
                    smsin: "0条",
                    monthfee: "23.9",
                    datain: "10GB",
                },
             
                {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 36.9,
                    productId: "1353936",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬移动流量卡20G",
                    smsin: "0条",
                    monthfee: "3.9",
                    datain: "0GB",
                },
                 {
                    voicefreerange: "全国",
                    voiceout: "0.15元/分钟",
                    dataout: "0.29元/MB",
                    amount: 68.9,
                    productId: "1353936",
                    smsout: "0.1元/条",
                    vsopin: "6",
                    name: "北纬移动流量卡G",
                    smsin: "0条",
                    monthfee: "3.9",
                    datain: "0GB",
                },
            ],
        }
    },

    components: {
        Popup,
        load,
        topHead,
    },

    computed: {
        ...mapState(["member", "verifyCode", "isNone"]),
    },

    created() {
        this.uesr()
        // this.ChoosePackage()
    },

    // 组件方法
    methods: {
        ChoosePackage() {
            API.getJson("RECHARGE_PRODUCT", {}).then(res => {
                this.mobilePhone = res.mobilePhone
                this.dayFlow = res.userprod.list
                this.detail = true
            })
        },

        // 选中套餐弹出提示框
        flowRecharge() {
            if ((this.SetMeal == "", this.currents == "")) {
                Toast({
                    position: "bottom",
                    message: "请选择流量套餐",
                })
            } else {
                this.show = true
            }
        },

        //选择套餐
        flowClick(index, id, type) {
            this.newofferId = id
            this.flag = id
            this.active = index
            this.monthFlow_li = null
            this[type + "_li"] = index
            console.log("33333333",this[type + "_li"]);
            this.SetMeal = this[type][index].name
            this.currents = this[type][index].amount
        },
        GoPackageDetails(id) {
            this.$router.push({
                path: "/PackageDetails",
                query: { id: id },
            })
        },

        //popup框取消回调
        onCancel() {
            this.show = false
        },

        uesr() {
            API.getJson("PERSONAL_DATA", {}).then(res => {
                this.packageId = res.mobilePhoneInfo.packageId
                this.packageName = res.mobilePhoneInfo.packageName
            })
        },

        //变更套餐
        openFlow() {
            this.show = false
            this.load = true
            let token = localStorage.getItem("token")
            API.getJson("PACKAGE_CHANGE", {
                token: token,
                packageId: this.packageId,
                newofferId: this.newofferId,
                packageName: this.packageName,
                newofferName: this.SetMeal,
            }).then(res => {
                this.load = false
                this.show = false
                if (res.rspCode == "0000") {
                    this.$router.push("/ChangeSucces")
                } else if (!res.rspCode == "000") {
                    Toast({
                        position: "bottom",
                        message: res.rspDesc,
                    })
                }
            })
        },
    },
}
</script> 

<style scoped lang='scss' >
.ChoosePackage {
    width: 100%;
    overflow-y: scroll;
}
.van-tabs {
    width: 100%;
    height: 80%;
    margin-top: px2rem(90);
    overflow: scroll;
}

.topHead {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    background: #fff;
    z-index: 99;
}

.conter p {
    display: flex;
    justify-content: space-between;
    padding: 0 px2rem(80);
    line-height: px2rem(56);
}
.conter p span {
    width: 50%;
    font-size: px2rem(26);
    color: #909198;
}
.conter p em {
    width: 50%;
    text-align: left;
    font-size: px2rem(28);
    color: #333;
    font-weight: 600;
}
.conter .conter_money em {
    color: #ff7505;
    font-size: px2rem(26);
}
.conter .conter_flow em {
    color: #336289;
}

.bottom {
    width: 100%;
    height: px2rem(80);
    line-height: px2rem(80);
    font-size: px2rem(26);
    font-weight: 800;
    color: #909198;
    border-top: 1px solid #909198;
    text-align: center;
}

.tab4_btn {
    position: absolute;
    right: px2rem(30);
    top: px2rem(28);
    padding: 0 px2rem(20);
    height: px2rem(44);
    line-height: px2rem(44);
    color: #4d4d4d;
    font-size: px2rem(24);
    background-color: #ffff1a;
    text-align: center;
    border-radius: px2rem(20);
}
.van-buttons {
    display: flex;
    justify-content: center;
    width: px2rem(550);
    height: px2rem(80);
    line-height: px2rem(80);
    margin-left: px2rem(60);
    color: #4d4d4d;
    font-weight: bold;
    font-size: px2rem(28);
    background-color: #ffff1a;
    // margin: px2rem(10) auto 0;
    margin: auto;
    box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
}

.van-submit-bar {
    width: 100%;
    height: px2rem(90);
    padding-left: px2rem(80);
    font-size: px2rem(36) !important;
    display: flex;
    justify-content: space-around;
    align-items: center;

    em {
        color: #ff802c;
        font-size: px2rem(40);
    }

    button {
        background: #336289;
        border-radius: 6%;
    }
}

.SetMeal {
    width: 100%;
    margin-bottom: px2rem(140);

    .SetMealLi {
        width: 100%;
        height: px2rem(240);
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: px2rem(32);
        background: #ffffe5;
        margin-top: px2rem(10);

        .SetMealLeft {
            width: 20%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .radio {
                width: px2rem(40);
                height: px2rem(40);
                border-radius: 50%;
                border: px2rem(1) solid #999999;
                display: flex;
                justify-content: center;
                align-items: center;

                p {
                    width: px2rem(20);
                    height: px2rem(20);
                    border-radius: 50%;
                    background: #999999;
                }
            }
        }

        .SetMealRight {
            width: 80%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 px2rem(20);
            padding-right: px2rem(40);

            .SetMealTitle {
                display: flex;
                justify-content: space-between;
                align-items: center;

                span {
                    font-size: px2rem(34);
                }

                em {
                    color: #ff802c;
                }
            }
            .particulars {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-top: px2rem(20);
                padding-right: px2rem(20);

                span {
                    font-size: px2rem(22);
                }

                p {
                    width: px2rem(120);
                    height: px2rem(50);
                    text-align: center;
                    line-height: px2rem(50);
                    border-radius: px2rem(10);
                    border: px2rem(1) solid #336289;
                    color: #336289;
                }
            }
        }
    }
}

.footer {
    width: 100%;
    height: px2rem(120);
    line-height: px2rem(120);
    position: fixed;
    bottom: 0;
    left: 0;
    // z-index: 100;
    color: #cccccc;
    background: #f0f5f5;
    padding-left: px2rem(20);

    span {
        font-size: px2rem(30);
        margin-left: px2rem(30);
        em {
            color: #ff802c;
            font-size: px2rem(40);
        }
    }

    button {
        position: absolute;
        right: px2rem(50);
        top: px2rem(24);
        width: px2rem(250);
        height: px2rem(80);
        font-weight: bold;
        font-size: px2rem(40) !important;
        border-radius: 6%;
        margin-left: px2rem(60);
        color: #000000;
        background-color: #ffff1a;
        box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
    }
}

.SetMeals {
    width: 100%;
    color: #336289;
    background: #ffffb3 !important;

    .radio {
        border: px2rem(1) solid #e5e600 !important;

        p {
            background: #e5e600 !important;
        }
    }
}
</style>

<style>
.back {
    color: #4e7697;
    background-color: #bdcbd0;
    border-radius: 7px;
}
.pay {
    color: #fff;
    background-color: #336289;
    border-radius: 7px;
}
.van-toast {
    font-size: 0.6rem !important;
}
</style>